import React, { useCallback, useState } from "react";
import { Search, X } from "lucide-react";
import useMediaQuery from "./useMediaQuery";

export default function SearchBar({
  disabled = false,
  searchTerm,
  setSearchTerm,
  setDebouncedTerm,
  placeholder = "Search",
  fullWidth = false,
  height = 34,
}) {
  const [focused, setFocused] = useState(false);
  const isMobile = useMediaQuery("(max-width: 640px)");

  const handleClear = useCallback(() => {
    setSearchTerm("");
    setDebouncedTerm?.("");
  }, [setSearchTerm, setDebouncedTerm]);

  return (
    <div
      style={{
        position: "relative",
        width: isMobile || fullWidth ? "100%" : 190,
        minWidth: isMobile || fullWidth ? 0 : 190,
        flexShrink: isMobile || fullWidth ? 1 : 0,
        marginRight: isMobile || fullWidth ? 0 : 10,
      }}
    >
      <Search
        size={14}
        style={{
          position: "absolute",
          left: 12,
          top: "50%",
          transform: "translateY(-50%)",
          color: focused ? "#00ADB5" : "#c3c8cc",
          pointerEvents: "none",
          transition: "color 0.15s",
        }}
      />
      <input
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        placeholder={placeholder}
        disabled={disabled}
        aria-label="search"
        style={{
          width: "100%",
          height,
          boxSizing: "border-box",
          borderRadius: 9,
          background: focused ? "rgba(255,255,255,0.05)" : "rgba(255,255,255,0.03)",
          border: focused ? "1px solid rgba(0,173,181,0.45)" : "1px solid transparent",
          boxShadow: focused ? "0 0 0 3px rgba(0,173,181,0.12)" : "none",
          color: "#fff",
          fontSize: 13,
          padding: `0 ${searchTerm ? 30 : 12}px 0 34px`,
          outline: "none",
          transition: "background 0.15s, border-color 0.15s, box-shadow 0.15s",
        }}
      />
      {searchTerm && (
        <button
          type="button"
          onClick={handleClear}
          aria-label="clear search"
          style={{
            position: "absolute",
            right: 8,
            top: "50%",
            transform: "translateY(-50%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 20,
            height: 20,
            borderRadius: 6,
            background: "transparent",
            border: "none",
            color: "#c3c8cc",
            cursor: "pointer",
          }}
        >
          <X size={13} />
        </button>
      )}
    </div>
  );
}
